import { getArticleCategories } from '../../api/api'
import { ArticleList } from '../../pages/ArticleList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/articles')({
  component: ArticleList,
  loader: async () => {
    const categories = await getArticleCategories()
    return {
      categories
    }
  }
})